import { v4 as uuidV4 } from 'uuid';
import { getClientId as retrieveClientId, setClientId } from './jwtHelpers';
export const getClientId = async () => {
    let client_id = null;
    try {
        client_id = await retrieveClientId();
    }
    catch {
        // No op
    }
    if (!client_id) {
        client_id = uuidV4();
        setClientId(client_id);
    }
    return client_id;
};
